import React from "react";
import AttendanceForm from "./Attendance";

const CheckOut = () => {
  return <AttendanceForm type="checkout" />;
};

export default CheckOut;
